webpackJsonp([1],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalForm__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modalForm__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'modalForm',
    component: __WEBPACK_IMPORTED_MODULE_2__components_modalForm___default.a
  }]
}));

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(39),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);







Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$axios', { value: __WEBPACK_IMPORTED_MODULE_4_axios___default.a });
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$VueAxios', { value: __WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
});

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modalForm__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modalForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modalForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      vehicle_price: 25000,
      down_payment: 0,
      dpDecimal: 0,
      dpValue: 0,
      loan_duration: 4,
      durationInMonths: 0,
      interest_rate: 1.24,
      totalFinanced: 9725,
      monthly_payment: 0,
      adminFee: 3000
    };
  },

  computed: {
    calc_total_financed: function calc_total_financed() {
      this.dpDecimal = this.down_payment / 100;
      this.dpValue = this.vehicle_price * this.dpDecimal;
      this.totalFinanced = this.vehicle_price - this.dpValue;
      return Math.floor(this.totalFinanced);
    },
    calc_monthly_paymt: function calc_monthly_paymt() {
      this.durationInMonths = this.loan_duration * 12;

      this.monthly_payment = (this.totalFinanced + this.adminFee) * this.calc_interest_rate(this.durationInMonths) / this.durationInMonths;
      return Math.floor(this.monthly_payment);
    },
    calculation_valid: function calculation_valid() {
      return this.monthly_payment > -1;
    }
  },
  components: {
    'modal-form': __WEBPACK_IMPORTED_MODULE_0__components_modalForm___default.a
  },
  methods: {
    calc_interest_rate: function calc_interest_rate(loanDuration) {
      var interestRate = 1.24;
      switch (loanDuration) {
        case 48:
          interestRate = 1.24;
          break;
        case 60:
          interestRate = 1.30;
          break;
        case 72:
          interestRate = 1.36;
          break;
        case 84:
          interestRate = 1.42;
          break;
      }
      return interestRate;
    }
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      dialog: false,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      },
      agree: false,
      formSubInProgress: false,
      showFormMsg: false,
      formSuccess: false,
      formMsg: '',
      serverErrors: '',
      IsServerErrors: 'false'
    };
  },

  props: ['vehicle_price', 'down_payment', 'loan_duration', 'interest_rate', 'monthly_payment'],
  computed: {
    form_valid: function form_valid() {
      var valid = [];
      if (this.rules.required(this.first_name) !== true) {
        valid.push('1');
      }
      if (this.rules.required(this.last_name) !== true) {
        valid.push('1');
      }
      if (this.rules.required(this.email) !== true) {
        valid.push('1');
      }
      if (this.rules.email(this.email) !== true) {
        valid.push('1');
      }
      if (this.rules.required(this.agree) !== true) {
        valid.push('1');
      }
      return valid.length <= 0;
    }
  },
  methods: {
    submit_form: function submit_form() {
      var api = 'http://fordtrinidad.com/index.php?id=28';
      var vi = this;

      var params = new URLSearchParams();
      params.append('first_name', this.first_name);
      params.append('last_name', this.last_name);
      params.append('email', this.email);
      params.append('phone', this.phone);
      params.append('vehicle_price', this.vehicle_price);
      params.append('down_payment', this.down_payment);
      params.append('loan_duration', this.loan_duration);
      params.append('interest_rate', this.interest_rate);
      params.append('monthly_payment', this.monthly_payment);
      this.formSubInProgress = true;
      this.$axios({
        method: 'post',
        url: api,
        data: params,
        timeout: 2000
      }).then(function (response) {
        if (response.data.success) {
          vi.setupFormFeedback(false, true, true, 'Your request has been submitted for approval');
          vi.clearForm();
        } else {
          console.log(response.data.message);
          vi.setupFormFeedback(false, true, false, response.data.message);
        }
      }).catch(function () {
        vi.setupFormFeedback(false, true, false, 'An error has occurred please try again.');
      });
    },
    setupFormFeedback: function setupFormFeedback(formSubInProgress, showFormMsg, formSuccess, formMsg) {
      this.formSubInProgress = formSubInProgress;
      this.showFormMsg = showFormMsg;
      this.formSuccess = formSuccess;
      this.formMsg = formMsg;
    },
    clearForm: function clearForm() {
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.phone = '';
      this.agree = false;
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "finance_calculator",
      "dark": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('v-card-text', {
    staticClass: "subheading orange lighten-3 mb-5"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "medium": "",
      "light": ""
    }
  }, [_vm._v("info")]), _vm._v(" Once you have decided on the perfect vehicle, we'll work with you to arrange your financing. We have a variety of terms to suit your needs. Enter your email address and phone\n                    number to get pre-approved before you buy, putting more negotiating power in your hands.\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Price of Vehicle")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "dark": "",
      "tabindex": "0",
      "max": 500000,
      "min": 1
    },
    model: {
      value: (_vm.vehicle_price),
      callback: function($$v) {
        _vm.vehicle_price = $$v
      },
      expression: "vehicle_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": "500000",
      "min": 1,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "prefix": "$"
    },
    model: {
      value: (_vm.vehicle_price),
      callback: function($$v) {
        _vm.vehicle_price = $$v
      },
      expression: "vehicle_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Downpayment")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "tabindex": "1",
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.down_payment),
      callback: function($$v) {
        _vm.down_payment = $$v
      },
      expression: "down_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": 99,
      "min": 10,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "suffix": "%"
    },
    model: {
      value: (_vm.down_payment),
      callback: function($$v) {
        _vm.down_payment = $$v
      },
      expression: "down_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Payment term")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "max": 7,
      "min": 4
    },
    model: {
      value: (_vm.loan_duration),
      callback: function($$v) {
        _vm.loan_duration = $$v
      },
      expression: "loan_duration"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": 7,
      "min": 1,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "suffix": "Years"
    },
    model: {
      value: (_vm.loan_duration),
      callback: function($$v) {
        _vm.loan_duration = $$v
      },
      expression: "loan_duration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calculation_valid),
      expression: "calculation_valid"
    }],
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md9": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("Your total amount for financing is")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "headline"
  }, [_vm._v("$ " + _vm._s(_vm.calc_total_financed))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md9": "",
      "lg9": "",
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("Your total monthly payment is")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "lg3": "",
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "headline green--text text--lighten-1"
  }, [_vm._v("$ " + _vm._s(_vm.calc_monthly_paymt))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs-12": ""
    }
  }, [_c('modal-form', {
    attrs: {
      "vehicle_price": _vm.vehicle_price,
      "down_payment": _vm.dpValue,
      "loan_duration": _vm.loan_duration,
      "interest_rate": _vm.interest_rate,
      "monthly_payment": _vm.monthly_payment
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.calculation_valid),
      expression: "!calculation_valid"
    }],
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title red--text text--accent-3"
  }, [_vm._v("The data you entered is not valid.")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalform"
  }, [_c('v-dialog', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "width": 420,
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "primary": "",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("Get Pre-approved")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormMsg),
      expression: "showFormMsg"
    }],
    attrs: {
      "success": _vm.formSuccess,
      "value": "true",
      "error": _vm.formSuccess != true
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formMsg)
    }
  })]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Get Pre-approved")])]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "light": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "light": "",
      "label": "First name",
      "required": "",
      "maxlength": 60
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "light": "",
      "label": "Last name",
      "required": "",
      "maxlength": 60
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = $$v
      },
      expression: "last_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "light": "",
      "label": "Email",
      "type": "email",
      "max": "15",
      "rules": [_vm.rules.required, _vm.rules.email],
      "maxlength": 60
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "light": "",
      "label": "Phone",
      "maxlength": 60
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('v-card-title', [_c('v-chip', {
    staticClass: "red red--text",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v("Disclaimer and User Agreement*")]), _vm._v("\n            * Calculation results are approximations and for information purposes only. Rates used for calculations are not considered rate guarantees or offers. All loans are subject to standard credit approval.\n          ")], 1)], 1), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "I Agree",
      "light": "",
      "required": ""
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "light": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_valid),
      expression: "form_valid"
    }],
    staticClass: "blue--text darken-1",
    attrs: {
      "light": "",
      "flat": "",
      "loading": _vm.formSubInProgress
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit_form($event)
      }
    }
  }, [_vm._v("Send")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(40),
  /* scopeId */
  "data-v-6e3a7848",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[32]);


// WEBPACK FOOTER //
// static/js/app.d742480ce05919da2ea5.js